import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { faqs } from '../data/faqs';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-brand-white" aria-labelledby="faq-heading" data-id="element-13" data-mp="1l9o8dd7a47nu">
      <div className="mx-auto max-w-3xl px-5 py-16 sm:px-8 sm:py-20 lg:py-24" data-id="element-14" data-mp="1ge8uwmd6odry">
        <h2 id="faq-heading" className="font-display text-3xl font-extrabold leading-tight tracking-tight sm:text-4xl" data-id="element-15" data-mp="2dzemhm8wv9jy">
          Straight answers
        </h2>

        <div className="mt-10 border-t border-brand-light" data-id="element-16" data-mp="241h0l5eixoui">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} className="border-b border-brand-light" data-id="element-17" data-mp="sn3heduptxkt" data-mpi={index}>
                <h3 data-id="element-18" data-mp="sl0guzvxsm1u">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-center justify-between gap-6 py-5 text-left font-display text-base font-bold transition-colors duration-150 ease-out hover:text-brand-red focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-red sm:text-lg" data-id="element-19" data-mp="no0ccteqjrcu">
                    {faq.question}
                    {isOpen ? <MinusIcon className="h-5 w-5 flex-none text-brand-red" aria-hidden="true" data-id="element-20" data-mp="biexv4it3enx" /> : <PlusIcon className="h-5 w-5 flex-none text-brand-gray" aria-hidden="true" data-id="element-21" data-mp="3t07vebo5ju7x" />}
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-22" data-mp="3jxq59m5dmhfn">
                  {isOpen && <motion.div id={`faq-panel-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-23" data-mp="3nzbqbus2e20x">
                      <p className="max-w-2xl pb-6 pr-10 text-sm leading-relaxed text-brand-gray sm:text-base" data-id="element-24" data-mp="1fsgjtlf1ena0">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}